module.exports = __webpack_public_path__ + "img/Warning.1a4283cb.png";